// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"rv_a bii_a bii_r bii_sb bii_ry bii_rz","GroupsGrid__row__item":"rv_b bii_be bii_rz"};